import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// import { PostHogProvider} from 'posthog-js/react'

// const options = {
//   api_host: "https://eu.i.posthog.com",
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>  
      <App />
  </React.StrictMode>
);
